import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow", "label"]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    this.arrowTarget.style.transform = "rotate(180deg)"
    
    // Add click listener to close when clicking outside
    setTimeout(() => {
      document.addEventListener("click", this.boundCloseOnOutsideClick)
    }, 100)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.arrowTarget.style.transform = "rotate(0deg)"
    
    // Remove click listener
    document.removeEventListener("click", this.boundCloseOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  selectOption(event) {
    // Update the label text
    const selectedText = event.currentTarget.dataset.value
    this.labelTarget.textContent = selectedText
    
    // Close the dropdown
    this.close()
    
    // Let the link navigate normally
    return true
  }
} 